import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { Icon } from '@garnish/core';

import { FlexLandingPageContent } from './FlexLandingPageContent';

export const FlexLandingPageLogo = (props: FlexLandingPageLogoProps) => {
  const { placement = 'content' } = props;
  const isHeader = placement === 'header';
  const Container = isHeader ? View : FlexLandingPageContent;

  return (
    <Container style={[styles.container, isHeader && styles.headerContainer]}>
      <Icon
        name="IconFlex"
        color={theme.colors.CHARCOAL}
        width={isHeader ? ICON_WIDTH_HEADER : ICON_WIDTH_CONTENT}
        height={isHeader ? ICON_HEIGHT_HEADER : ICON_HEIGHT_CONTENT}
      />

      <View style={[styles.divider, isHeader ? styles.headerDivider : null]} />

      <Icon
        name="IconSweetgreenFull"
        color={theme.colors.CHARCOAL}
        width={isHeader ? LOGO_WIDTH_HEADER : LOGO_WIDTH_CONTENT}
        height={isHeader ? LOGO_HEIGHT_HEADER : LOGO_HEIGHT_CONTENT}
        style={styles.sweetgreenLogo}
      />
    </Container>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const ICON_WIDTH_CONTENT = 60;
const ICON_HEIGHT_CONTENT = 28;

const ICON_WIDTH_HEADER = 43;
const ICON_HEIGHT_HEADER = 20;

const LOGO_WIDTH_CONTENT = 147;
const LOGO_HEIGHT_CONTENT = 28;

const LOGO_WIDTH_HEADER = 105;
const LOGO_HEIGHT_HEADER = 20;

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    height: 60,
    gap: theme.spacing['3'],
  },
  headerContainer: {
    height: 40,
    justifyContent: 'center',
    gap: theme.spacing['2'],
  },
  divider: {
    width: 1,
    height: 40,
    backgroundColor: theme.colors.CHARCOAL,
  },
  headerDivider: {
    height: 28,
  },
  sweetgreenLogo: {
    marginTop: theme.spacing['2'],
  },
});

type FlexLandingPageLogoProps = {
  placement?: 'content' | 'header';
};
